<template>
  <div>
    <div class="select_area block">
      <el-row>
        <el-col :span="8">
          <span class="item_title">请选择地区：</span>
          <div style="width: 100%">
            <up-cascader ref="distribute" v-if="areaOptions.length > 0" v-model="selectedArea" :filterable="true"  :remote="false" :props="{multiple: true}"  :clearable="true"
                              :options="areaOptions"  @change="handleChangeArea" :maxCount="2"
                         :myClass=" type== 1 ? 'cascader-indst-tags' : 'cascader-indst-tags2'"
                         :class=" type== 1 ? 'cascader-indst-tags' : 'cascader-indst-tags2'"
                        placeholder="请选择地区" />
<!--            <el-cascader collapse-tags class="cascader" ref="cascader"  :options="options" :props="props" clearable v-model="selectedArea" @change="handleChangeArea"></el-cascader>-->
          </div>
        </el-col>
        <el-col :span="8">
          <span class="item_title">请选择经销商：</span>
          <div class="choose_distribute">
<!--            <upMultipleSelect ref="selectDistribute" v-model="primary_distributor_selected" :filterable="true"  :remote="true" :multiple="true" :remote-method="remoteMethod"  :clearable="true"-->
<!--                       :options="organizationList"  @change="handle_change_distribute" :maxCount="2" :myClass="'select-hospname-tags'"-->
<!--                            class="select-hospname-tags" placeholder="请输入一级经销商" />-->

            <el-select
                multiple
                v-model="primary_distributor_selected"
                placeholder="请输入一级经销商"
                class="custom-select"
                size="small"
                filterable
                clearable
                remote
                :loading="searchLoading"
                collapse-tags
                :remote-method="(query)=>handleSearch(query)"
                @change="handle_change_distribute"
            >
              <el-option
                  v-for="item in organizationList"
                  :disabled="item.disabled"
                  :key="item.customer"
                  :label="item.customer_name"
                  :value="{label:item.customer_name,value:item.customer,provinceId: item.province.value,provinceName: item.province.label,city:item.city.value}"
              ></el-option>
            </el-select>
            <div class="block" v-if="selectedArea.length > 0 " style="margin-top: 10px">
              <el-checkbox v-model="checkedAll" @change="handle_select_all()">全部经销商</el-checkbox>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="result_area block">
      <div>
        <div class="left" style="display: inline-block;width: 50%;">
          <span class="item_title">已选择经销商：</span>
          <el-checkbox v-model="checkedAllSelected" @change="handle_del_select_all()">全选</el-checkbox>
          <el-button @click="handle_delete()" size="mini" style="margin-left: 14px;background: #BD3124;color: #fff;border:none;">全部删除</el-button>
        </div>
        <div style="display: inline-block;width: 50%;text-align: right">
          <el-input v-model="key_word" size="mini" placeholder="请输入关键字" style="display: inline-block;width: 170px"></el-input>
          <el-button size="mini" @click="handle_filter" style="vertical-align: top; margin-left: 14px;background: #0052D9;color: #fff;">查找</el-button>
        </div>
      </div>
      <div  class="tag_list">
        <span v-for="item in distrDisplayList" style="display: block" :key="item.value">
          <span style="margin-right: 14px;font-weight: bold;">{{item.provinceName ? item.provinceName : '其它'}}:</span>
          <el-tag
              v-for="tag in item.customer_list"
              class="item_tag"
              :class="{ 'active-class': tag.isActive,}"
              effect="dark"
              @close="handleClose(tag)"
              closable>
            {{tag.label}}
          </el-tag>
        </span>
      </div>
    </div>
    <el-dialog
        title=""
        :visible.sync="distr_dialogVisible"
        width="30%"
        :modal="false"
        :modal-append-to-body="false"
        :before-close="handleCloseDelete">
      <span>删除后不可恢复，确认要删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="distr_dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeleteAll" style="background: #0052D9">确定删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { search_customer} from "@/api/search";
import api from "@/api/manage";
import upMultipleSelect from "@/components/upMultipleSelect.vue";
import upCascader from "@/components/upCascader.vue";
export default {
  components: {upMultipleSelect,upCascader},
  props:{
    customerDataInfo:{
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      searchLoading:false,
      key_word: '',
      checkedAll: false,
      checkedAllSelected: false,
      selectSubmitList:[], //选中提交的list
      displayList:[], //展示的list
      selectedArea: [],
      selectedAreaVal: [],
      selectedValues: [], // 选中的经销商
      primary_distributor_selected: [],
      primary_distributor_id: [],
      props: { multiple: true },
      checked: false,
      organizationList:[],
      areaOptions: [],
      salesList: [],
      distr_dialogVisible: false,
      distrSelectOriginList: [], //选中的原始数据，可能不是展示数据，但是提交的原始数据
      distrSelectOriginListTemp: [], //选中的要展示的原始数据，主要为了区分筛选后的数据
      distrDisplayList: [], // 处理过最终展示的选中数据（可能是筛选过的，但不是提交的数据）
      distrSelectSubmitList: {}, //处理过最终的提交数据
      allCustomLength: 0,
    };
  },
  watch: {
    customerDataInfo(val){
      // console.log('customerDataInfo-jianting222')
      if(val){
        this.initData()
      }
    }
  },
  mounted() {
    let originData = JSON.parse(localStorage.getItem('province'));
    this.areaOptions = originData
  },
  methods: {
    initData(){
      if(this.customerDataInfo.length >0){
        let customerDataInfoTemp = this.customerDataInfo
        customerDataInfoTemp.forEach((item) => {
          item.label = item.organization_name
          item.value = item.organization_id
          item.provinceName = item.province_name
          item.provinceId = item.province_id
          item.cityName = item.city_name
          item.cityId = item.city_id
          item.city = item.city_id
        })
        // console.log('customerDataInfoTemp==',customerDataInfoTemp)
        this.distrSelectOriginList = customerDataInfoTemp
        this.distrSelectOriginListTemp = customerDataInfoTemp
        this.rebuildDisplayData()
        this.rebuildSubmitData()
      }
    },
    rebuildDisplayData(){
      const result = [];
      const provinceMap = new Map();

      this.distrSelectOriginListTemp.forEach(item => {
        const { provinceId, provinceName, value, label } = item;

        if (!provinceMap.has(provinceId)) {
          provinceMap.set(provinceId, {
            provinceId,
            provinceName,
            customer_list: []
          });
        }

        const provinceInfo = provinceMap.get(provinceId);
        provinceInfo.customer_list.push({ value, label });
      });

      // 将Map转换为数组，并根据省份ID进行排序（如果需要）
      // 同时，对每个省份下的客户列表按照value值进行排序
      const sortedArray = Array.from(provinceMap.entries()).map(([provinceId, provinceInfo]) => {
        provinceInfo.customer_list.sort((a, b) => a.value - b.value);
        return provinceInfo;
      }).sort((a, b) => a.provinceId - b.provinceId);
      // console.log('sortedArray:', sortedArray);
      this.distrDisplayList = sortedArray;
      return sortedArray;
      // 输出结果以验证

    },
    rebuildSubmitData(){
      const areaData = [];
      const customerIds = [];
      const provinceMap = new Map();

      this.distrSelectOriginList.forEach(item => {
        const { provinceId, city, value } = item;

        // 将value添加到customerIds数组中
        customerIds.push(value);

        if (!provinceMap.has(provinceId)) {
          // 如果provinceMap中还没有这个provinceId，则创建一个新的对象并添加到areaData数组中
          areaData.push({
            province_id: provinceId,
            city: []
          });
          provinceMap.set(provinceId, areaData[areaData.length - 1]);
        }

        // 将city添加到对应provinceId的city数组中
        const provinceInfo = provinceMap.get(provinceId);
        if (!provinceInfo.city.includes(city) && !!city) { // 避免重复添加相同的city
          provinceInfo.city.push(city);
        }
      });
      this.customer_permission=  {
        area_data: areaData,
            customer_ids: [...new Set(customerIds)] // 使用Set去重，然后转换回数组
      }
      // 输出结果以验证

      // console.log('customer_permission:', this.customer_permission);
      this.distrSelectSubmitList = this.customer_permission;
    },
    handleChangeArea(value, selectedData) { // 下拉选择区域
      if(value.length > 0){
        this.selectedAreaVal = this.selectedArea.map(subArray => subArray[0]);
      }
    },
    // 防抖处理后的搜索方法
    handleSearch: debounce(function(event) {
      const keyword = event;
      if (this.selectedAreaVal.length > 0 || keyword) {
        this.remoteMethod(keyword); // 实际搜索逻辑
      }
    }, 1500),
    handle_select_all(){
      if(this.checkedAll){
        this. remoteMethod('','','all')
      }
    },
    async remoteMethod(query, index,type) { // 远程搜索经销商
      // this.organizationList = search_customer({ customer_name: query })
      this.selectedAreaVal = [...new Set(this.selectedAreaVal)]
      let params = {
        type: 'customer',
        province_id: this.selectedAreaVal.toString(),
        customer_name: query
      }
      this.searchLoading = true
      api.system_search_data(params).then(res => {
        this.organizationList = res.data
        this.searchLoading = false
        const existCustomerIds = new Set(
            this.distrSelectOriginList.map(item => item.value)
        );
        this.organizationList.forEach(org => {
          org.disabled = existCustomerIds.has(org.customer);
        });
        if (type == 'all') { // 全选
          let resData = res.data
          this.allCustomLength = resData.length
          resData.forEach((item) => {
            item.label = item.customer_name
            item.value = item.customer
            item.provinceName = item.province.label
            item.provinceId = item.province.value
            item.cityName = item.city.label
            item.city = item.city.value
          })
          this.primary_distributor_selected = resData
          this.distrSelectOriginList = this.distrSelectOriginList.concat(resData)
          this.distrSelectOriginListTemp = this.distrSelectOriginListTemp.concat(resData)
          this.distrSelectOriginList = Array.from(new Map(this.distrSelectOriginList.map(item => [item.value, item]))).map(item => item[1]);
          this.distrSelectOriginListTemp = Array.from(new Map(this.distrSelectOriginListTemp.map(item => [item.value, item]))).map(item => item[1]);
          this.rebuildDisplayData()
          this.rebuildSubmitData()
        }
      }).finally(() => {
        this.searchLoading = false
      })
      // console.log('this.organizationList====',this.organizationList)
    },
    handle_change_distribute(e){ // 下拉选中某个经销商
      // console.log('下拉选中某个经销商===',e)
      this.distrSelectOriginList = this.distrSelectOriginList.concat(e)
      this.distrSelectOriginListTemp = this.distrSelectOriginListTemp.concat(e)
      this.distrSelectOriginList = Array.from(new Map(this.distrSelectOriginList.map(item => [item.value, item]))).map(item => item[1]) ;
      this.distrSelectOriginListTemp = Array.from(new Map(this.distrSelectOriginListTemp.map(item => [item.value, item]))).map(item => item[1]) ;
      this.rebuildDisplayData()
      this.rebuildSubmitData()

    },
    handleClose(tag) { // 删除某个选中的经销商
      console.log('tag===',tag)
      this.distrSelectOriginListTemp = this.distrSelectOriginListTemp.filter(item => item.value !== tag.value)
      this.distrSelectOriginList = this.distrSelectOriginList.filter(item => item.value !== tag.value)
      console.log('distrDisplayList===',this.distrDisplayList)
      this.distrDisplayList.forEach((item,index) =>{
        console.log('item===',item)
        item.customer_list.forEach((i,index)=>{
          if(i.value === tag.value){
            item.customer_list.splice(index, 1)
          }
          if(item.customer_list.length == 0){
            this.distrDisplayList.splice(index, 1)
          }
        })
      })
      this.rebuildDisplayData()
      this.rebuildSubmitData()
      this.primary_distributor_selected = this.primary_distributor_selected.filter(item => item.value !== tag.value)
      if(this.allCustomLength > this.primary_distributor_selected.length){
        console.log('ssss')
        this.checkedAll = false
      }
      // this.displayList = this.displayList.filter(item => item.value !== tag.value);
      // this.selectSubmitList = this.selectSubmitList.filter(item => item.value !== tag.value);
      // this.primary_distributor_selected = this.selectSubmitList
    },
    handle_del_select_all(e){ //选择某地区下的所有的经销商
      // console.log('checkedAllSelected===',this.checkedAllSelected)
      if(this.checkedAllSelected){
        this.distrDisplayList.forEach(item =>{
          item.customer_list.forEach(i=>{
            i.isActive = true
          })

        })
      }else{
        this.distrDisplayList.forEach(item =>{
          item.customer_list.forEach(i=>{
            i.isActive = false
          })
        })
      }
      // console.log('this.displayList',this.displayList)
    },
    handle_delete(){
      this.distr_dialogVisible = true
    },
    confirmDeleteAll(){
      this.handle_delete_all()
      this.distr_dialogVisible = false
    },
    handle_delete_all(){ // 删除展示区域选中的所有的经销商
      if(this.key_word){
        const array1 = this.distrSelectOriginList
        const array2 = this.distrSelectOriginListTemp
        this.distrSelectOriginList = array1.filter(item1 =>
            !array2.some(item2 => item2.value == item1.value)
        );
      }else{
        this.distrSelectOriginList = []
      }
      this.distrSelectOriginListTemp = []
      this.primary_distributor_selected = this.distrSelectOriginList
      // console.log('this.selectSubmitList==',this.selectSubmitList)
      this.checkedAllSelected = false
      this.rebuildDisplayData()
      this.rebuildSubmitData()
    },
    handle_filter(){ // 筛选
      // const array = this.selectSubmitList
      // this.displayList = array.filter(item => item.label.includes(this.key_word));
      // console.log('this.displayList===',this.displayList)
      this.distrSelectOriginListTemp =  this.distrSelectOriginList.filter(item => item.label.includes(this.key_word))
      this.rebuildDisplayData()
    },
    handleCloseDelete(){
      this.distr_dialogVisible = false
    }

  }
};
</script>
<style scoped lang="scss">
.block{
  display: block;
  .item_title{
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}
.result_area{
  margin-top: 20px;
}
.item_tag{
  margin:10px 14px 4px 0;
  background: #EFEFEF 50%;
  color: #4F4F4F;
  border:none;
  position: relative;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  top: -2px;
}
::v-deep .result_area .el-tag__close.el-icon-close{
  position: absolute;
  top: -8px;
  right: -8px;
  background: #BD3124;
}
::v-deep .choose_distribute .el-input__inner{
  width: 100%;
}
::v-deep .item_tag.active-class{
  border: 1px solid #0052D9;
}
::v-deep .custom-select .el-tag {
  display: inline-block;
  //max-width: 130px; /* 根据需要调整宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .el-select.custom-select{
  width: 100%;
}
::v-deep .custom-select .el-tag + .el-tag {
  margin-left: 6px; /* 调整标签之间的间距 */
}
::v-deep .custom-select .el-tag:nth-child(n+3) {
  display: none; /* 隐藏第三个及以后的标签 */
}
::v-deep .custom-select .el-tag:nth-child(2) {
  margin-right: 4px; /* 在第二个标签后留出一些空间 */
}
//::v-deep  .custom-select .el-tag:nth-child(2)::after {
//  content: "+";
//  margin-left: 4px;
//}
::v-deep .el-cascader.el-cascader .el-input .el-input__inner{
  width: 100%;
}
.result_area{
  margin-top: 20px;
  border-radius: 5px;
  padding: 14px 12px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(239,239,239,1);
  .tag_list{
    max-height: 300px;
    overflow: auto;
  }
}
::v-deep .result_area .el-input__inner{
  width: 100%!important;
}
</style>